export const VOYAGE_PER_TRAYEK_URL = 'dashboard/voyage_per_trayek'
export const VOYAGE_PER_TRAYEK_ERROR = 'VOYAGE_PER_TRAYEK_ERROR'
export const VOYAGE_PER_TRAYEK_LOADING = 'VOYAGE_PER_TRAYEK_LOADING'
export const VOYAGE_PER_TRAYEK_SUCCESS = 'VOYAGE_PER_TRAYEK_SUCCESS'